export default "__VITE_ASSET__Cbng49AL__"